"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TriggerClass_1 = __importDefault(require("./TriggerClass"));
var Immediately = /** @class */ (function (_super) {
    __extends(Immediately, _super);
    function Immediately() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Immediately.prototype.init = function (actionCallback) {
        var _this = this;
        if (this.hasRendered)
            return;
        setTimeout(function () {
            actionCallback();
            _this.hasRendered = true;
        }, 0);
    };
    Immediately.prototype.toString = function () {
        return 'triggered immediately';
    };
    return Immediately;
}(TriggerClass_1.default));
exports.default = Immediately;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW1tZWRpYXRlbHkuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90cmlnZ2Vycy9JbW1lZGlhdGVseS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdFQUE0RDtBQUU1RDtJQUF5QywrQkFBWTtJQUFyRDs7SUFZQSxDQUFDO0lBWEcsMEJBQUksR0FBSixVQUFLLGNBQTZCO1FBQWxDLGlCQU1DO1FBTEcsSUFBSSxJQUFJLENBQUMsV0FBVztZQUFFLE9BQU07UUFDNUIsVUFBVSxDQUFDO1lBQ1AsY0FBYyxFQUFFLENBQUE7WUFDaEIsS0FBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUE7UUFDM0IsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO0lBQ1QsQ0FBQztJQUVELDhCQUFRLEdBQVI7UUFDSSxPQUFPLHVCQUF1QixDQUFBO0lBQ2xDLENBQUM7SUFDTCxrQkFBQztBQUFELENBQUMsQUFaRCxDQUF5QyxzQkFBWSxHQVlwRCJ9